import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  documentTypeCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'documentTypeModel',
    'additionalFieldModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      DocumentType,
      AdditionalField
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('REPEAT ACRONYM'),
            modelState: err,
          };
        }
        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE REPOSITORY'),
        };
      }

      function sortColumns() {
        return [
          {
            column: 'name',
            title: 'NAME',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'acronym',
            title: 'ACRONYM',
            type: 'text',
            sortOrder: 'asc',
          },
          {
            column: 'description',
            title: 'DESCRIPTION',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();

        deferred.resolve([]);

        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();

        var filters = null;
        deferred.resolve(filters);

        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();

        var url = 'documentType';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new DocumentType(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function selectAdditionalFields(documentType, additionalFields) {
        documentType.additionalFields.forEach(function (c) {
          var fs = additionalFields.filter(function (d) {
            return d.id === c.IdAdditionalField;
          });
          fs[0].selected = true;
          fs[0].required = c.IsRequired;
        });
        documentType.allAdditionalFields = additionalFields;
      }

      function load(id) {
        var deferred = $q.defer();

        var documentType = new DocumentType();
        var additionalFields = null;
        var done = false;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'additionalField', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              additionalFields = [];
              data = resolveReferences(data);

              data.forEach(function (d) {
                var additionalField = new AdditionalField(d);
                additionalFields.push(additionalField);
              });

              if (id && documentType.id !== 0 && !done) {
                selectAdditionalFields(documentType, additionalFields);
                done = true;
                deferred.resolve(documentType);
              } else if (!id && !done) {
                documentType.allAdditionalFields = additionalFields;
                done = true;
                deferred.resolve(documentType);
              }
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        if (id) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
                'documentType/withFields/' +
                id,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                documentType = new DocumentType(data);

                if (additionalFields !== null && !done) {
                  selectAdditionalFields(documentType, additionalFields);
                  done = true;
                  deferred.resolve(documentType);
                }
              },
              function (err) {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              }
            );
        }

        return deferred.promise;
      }

      function save(documentType) {
        var deferred = $q.defer();

        if (documentType.hasRevisionInterval === false) {
          documentType.revisionInterval = null;
          documentType.notificationDays = null;
          documentType.canOverrideRevInterval = false;
        }

        documentType.documentTypesAdditionalFields = [];
        var additionalFields = documentType.allAdditionalFields.filter(
          function (d) {
            return d.selected;
          }
        );
        additionalFields.forEach((d) => {
          documentType.documentTypesAdditionalFields.push({
            IdDocumentType: documentType.id,
            IdAdditionalField: d.id,
            IsRequired: d.required,
          });
        });

        if (documentType.id === 0) {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'documentType',
              documentType,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(() => {
              deferred.resolve();
            })
            .catch((err) => {
              deferred.reject(handleError(err.data, err.status));
            });
        } else {
          $http
            .put(
              webApiSettings.apiServiceBaseUri + 'documentType',
              documentType,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();
        var url = 'documentType/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }
        $http
          .post(webApiSettings.apiServiceBaseUri + url, ids)
          .then((el) => {
            if (el.data.length !== 0) {
              deferred.reject({
                title: $filter('translate')('HAS ASSOCIATED DOCUMENTS'),
                text: el.data.RevisionsDepedency.Errors[0].ErrorMessage,
              });
              return deferred.resolve(false);
            }
            deferred.resolve(true);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function run() {
        try {
          var documentTypeCrudFactory = {};

          documentTypeCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          documentTypeCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );

          return documentTypeCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
